module.exports = __webpack_public_path__ + "media/Tiktok.5949a3f9.svg";